import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosGenericoAsync, cargarCatalogos, cargarCatalogosAsync } from '../../funciones_globales/catalogos';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

class FormCli08  extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            status_cli_sel: 'A',
            status_cli_opt: [],
            zona_sel: null,
            vendedor_sel: null,
        };
        this.changeComponents = this.changeComponents.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impfichaClienteVendedor = this.impfichaClienteVendedor.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        var value = target.type === 'checkbox' ? target.checked : target.value; 
        this.setState({[name]: value});
    }

    componentDidMount(){
        Promise.all([            
            cargarCatalogos('PROVINCIA'), cargarCatalogos('STATUSCLI'), 
            this.props.generar_LogAuditoriaIngresoForm('0108')           
        ])
        .then(([result_prov, result_statusClient])=> {  
                      
            this.setState({ provincia_opt: result_prov, status_cli_opt: result_statusClient})            
        })
        .catch((err)=>{
            console.log(err);
        }); 
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0108');
    }

    limpiar(){
        this.setState({status_cli_sel: 'A', provincia_sel: null, vendedor_sel: null,})
    }

    getOptions_Zona(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('ZONACLIEN', input, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    impfichaClienteVendedor(){
        var parametroURL = "";

        if(this.state.status_cli_sel!==null){
            parametroURL = parametroURL+'&param1='+this.state.status_cli_sel;
        }

        if(this.state.zona_sel!==null){
            parametroURL = parametroURL+'&param2='+this.state.zona_sel.value;
        }

        if(this.state.vendedor_sel!==null){
            parametroURL = parametroURL+'&param3='+this.state.vendedor_sel.value;
        }

        parametroURL = parametroURL+'&rpt=13';

        visualizarReporteEnPdf(parametroURL);
    }

    render(){
        return(
            <ContenedorForm porc_ancho={50}>
            <HeaderForm>
                <TituloForm>Fichas de Clientes por Vendedor</TituloForm>
            </HeaderForm>
            <CuerpoForm>                
                <Row>
                    <ContainerCol className='col-sm-2' margen_arriba="15">
                        <LabelForm>Estado:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-4' margen_arriba="15" margen_abajo='8'>
                        <ReactSelect options={ this.state.status_cli_opt } value={this.state.status_cli_sel} func_onChange={(value)=>{this.setState({status_cli_sel: value!==null?value.value:null})}}/>
                    </ContainerCol> 
                </Row>
                <Row>
                    <ContainerCol className='col-sm-2' margen_abajo='8'>
                        <LabelForm>Zona:</LabelForm>
                    </ContainerCol>
                    <ContainerCol className='col-sm-4' margen_abajo='8'>
                        <ReactSelectAsync value={this.state.zona_sel} func_loadOptions={this.getOptions_Zona} func_onChange={(value)=>{this.setState({zona_sel: value!==null?value:null})}}/>
                    </ContainerCol>
                </Row>
                <Row>
                    <ContainerCol className='col-sm-2' margen_abajo='8'>
                        <LabelForm>Vendedor:</LabelForm>
                    </ContainerCol>                
                    <ContainerCol className='col-sm-5' margen_abajo='8'>
                        <ReactSelectAsync value={this.state.vendedor_sel} func_loadOptions={this.getOptions_Vendedores} func_onChange={(value)=>{this.setState({vendedor_sel: value!==null?value:null})}}/>
                    </ContainerCol>
                </Row>
                <Row>
                    <ContainerCol className='col-sm-12'>
                        <div className='btn-group pull-right'>
                            <button type='button' className='btn btn-info btn-sm' onClick={()=>{this.impfichaClienteVendedor('PDF')}}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                            <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                        </div>
                    </ContainerCol>
                </Row>
            </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormCli08);